// extracted by mini-css-extract-plugin
export default {"overlay":"qjGGic","showOverlay":"x6_m4w","fixedBody":"m_Dd6Y"};